import { connect } from 'react-redux'
import ViewRoleCharted from 'modules/Roles/ViewRoleChart'
import rolesSelectors from 'modules/Roles/selectors'
import authSelector from 'modules/Auth/selectors'

import {
  getRoleViewChart,
  getRoleViewCard,
  getRoleViewCardATS,
  getDegreesBasedOnRoles,
  getSingleRoleData,
  getAppliedCandidateListTrue,
  getRoleCityData,
  getRoleDraftData,
} from 'modules/Roles/actions'

const mapStateToProps = state => ({
  roleViewCardData: rolesSelectors.getRoleViewCard(state),
  roleViewChartData: rolesSelectors.getRoleViewChart(state),
  roleViewCardDataATS: rolesSelectors.getRoleViewCardATS(state),
  roleBasedDegreeList: rolesSelectors?.getDegreeRolesList(state),
  singleRoleData: rolesSelectors?.getSingleRoleData(state),
  appliedCandidatesListTrue:
    rolesSelectors?.getAppliedCandidatesListTrue(state),
  draftData: rolesSelectors.getRoleDraftData(state),
  permissions: authSelector.getUserPermissions(state),
})

const mapDispatchToProps = {
  getRoleViewChart,
  getRoleViewCardATS,
  getRoleViewCard,
  getDegreesBasedOnRoles,
  getSingleRoleData,
  getAppliedCandidateListTrue,
  getRoleCityData,
  getRoleDraftData,
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewRoleCharted)
